import { FormPostSubmitType, FieldType, ButtonActionType } from "@wuilt/section-preview";
import { nanoid } from "nanoid";
const FIELDS_TYPES_MAPPER = {
  Text: FieldType.Text,
  Email: FieldType.Email,
  Phone: FieldType.Phone,
  MultiLineText: FieldType.TextArea
};
function migrateSettings(old) {
  // @ts-ignore has been migrated before
  if (old?.form_data?.formButton) return old.form_data;
  if (old?.texts) return old;
  const castedOld = old;
  const texts = {};
  function injectAndExtractTexts(content) {
    const textId = `Content:${nanoid()}`;
    Object.assign(texts, {
      [textId]: content
    });
    return {
      textId,
      content
    };
  }
  return {
    texts,
    formId: castedOld?.form_id,
    formName: castedOld?.form_data?.formName,
    formPostSubmit: {
      submitType: FormPostSubmitType.Message,
      successMessage: injectAndExtractTexts(castedOld?.form_data?.success_message),
      failureMessage: injectAndExtractTexts("")
    },
    notifications: {
      emails: [castedOld?.send_to]
    },
    formButton: {
      id: `Button:${nanoid()}`,
      action: {
        type: ButtonActionType.Submit
      },
      ...injectAndExtractTexts(castedOld?.form_data?.action?.label)
    },
    fields: castedOld?.form_data?.fields?.map?.(f => ({
      id: `Field:${nanoid()}`,
      type: FIELDS_TYPES_MAPPER[f?.type] || FieldType.Text,
      settings: {
        placeholder: injectAndExtractTexts(f?.label),
        label: injectAndExtractTexts(""),
        description: injectAndExtractTexts(""),
        errorMessage: injectAndExtractTexts(""),
        required: !!f?.required,
        autoComplete: f?.name
      }
    }))
  };
}
function injectIds(id, formId, settings) {
  settings.formId = formId || settings.formId;
  return {
    ...settings,
    id
  };
}
export function migrateElement(id, old) {
  const settingsX = migrateSettings(old);
  const settings = injectIds(id, old.form_id, settingsX);
  return {
    id: id,
    type: "Form",
    settings
  };
}
//# sourceMappingURL=form-migrations.js.map